module.exports = __webpack_public_path__ + "static/img/tcjy-header.46464014.png";